(function () {
  'use strict';
  var modal=document.getElementById('rk-lore-modal');
  if (!modal || !window.RushLore) return;
  document.body.appendChild(modal);
  var panel=modal.querySelector('.rk-lore-modal__panel'), target=modal.querySelector('[data-lore-target]');
  var closeButton=modal.querySelector('.rk-lore-modal__close'), loading=modal.querySelector('.rk-lore-modal__loading');
  var phase='closed', state=null, controller=null, request=null, closeTimer=0, enterTimer=0, ready=false, focusBefore=null;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');

  function load() {
    if (controller) return Promise.resolve(controller);
    if (request) return request;
    loading.hidden=false;
    target.querySelectorAll('.rk-lore-modal__error').forEach(function(el){el.remove();});
    var url=new URL(modal.dataset.loreUrl,location.href);
    var preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview) url.searchParams.set('preview_theme_id',preview);
    request=fetch(url.href,{credentials:'same-origin'}).then(function(res){
      if(!res.ok) throw new Error('Story request failed');
      return res.text();
    }).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var template=doc.querySelector('template[data-story-source]');
      controller=window.RushLore.mount(template?template.content:doc.querySelector('main')||doc,target,panel,{
        active:phase==='open' && ready, close:close,
        progress:modal.querySelector('.rk-lore-modal__progress span')
      });
      loading.hidden=true;
      return controller;
    }).catch(function(){
      loading.hidden=true;
      var error=document.createElement('div'); error.className='rk-lore-modal__error';
      var message=document.createElement('p'); message.textContent='The story couldn’t load. Please try again.';
      var retry=document.createElement('button'); retry.type='button'; retry.textContent='Try again';
      retry.addEventListener('click',load);
      var link=document.createElement('a'); link.href=url.href; link.textContent='Open the story page';
      error.append(message,retry,document.createElement('br'),link); target.appendChild(error);
    }).finally(function(){request=null;});
    return request;
  }
  function lock() {
    var body=document.body, html=document.documentElement, lenis=window.__lenis;
    state={y:window.scrollY||0,body:{},overflow:html.style.overflow,behavior:html.style.scrollBehavior,
      lenis:lenis&&!lenis.isStopped?lenis:null,inert:[]};
    ['position','top','left','right','width','overflow'].forEach(function(key){state.body[key]=body.style[key];});
    if(state.lenis) state.lenis.stop();
    html.style.overflow='hidden'; html.style.scrollBehavior='auto';
    body.style.position='fixed'; body.style.top=-state.y+'px';
    body.style.left='0';body.style.right='0';body.style.width='100%';body.style.overflow='hidden';
    Array.from(body.children).forEach(function(el){
      if(el===modal || ['SCRIPT','STYLE','LINK'].includes(el.tagName)) return;
      state.inert.push([el,el.inert]); el.inert=true;
    });
  }
  function unlock() {
    if(!state) return;
    var saved=state; state=null;
    saved.inert.forEach(function(pair){pair[0].inert=pair[1];});
    Object.keys(saved.body).forEach(function(key){document.body.style[key]=saved.body[key];});
    document.documentElement.style.overflow=saved.overflow;
    if(saved.lenis) {saved.lenis.start(); saved.lenis.resize();}
    window.scrollTo(0,saved.y);
    if(saved.lenis) saved.lenis.scrollTo(saved.y,{immediate:true,force:true});
    document.documentElement.style.scrollBehavior=saved.behavior;
    if(focusBefore && focusBefore.isConnected) focusBefore.focus({preventScroll:true});
  }
  function open(trigger) {
    if(phase==='open') return;
    clearTimeout(closeTimer);
    clearTimeout(enterTimer);
    ready=false;
    if(phase==='closed') {
      focusBefore=trigger||document.activeElement; lock();
      modal.hidden=false; modal.classList.add('is-active');
      // Commit the curtain's starting position before transitioning up.
      panel.getBoundingClientRect();
      panel.scrollTop=0;
    }
    if(controller && controller.prepare)controller.prepare();
    phase='open'; modal.setAttribute('aria-hidden','false');
    modal.classList.add('is-transitioning','is-open');
    // Stage the story only after the curtain lands, so its opening credits are
    // seen instead of playing underneath a panel still below the viewport.
    function entered(){
      if(phase!=='open' || ready)return;
      ready=true;modal.classList.remove('is-transitioning');
      if(controller)controller.setActive(true);
    }
    if(reduce.matches) entered();
    else enterTimer=setTimeout(entered,540);
    closeButton.focus({preventScroll:true});
    load();
  }
  function finishClose() {
    if(phase!=='closing') return;
    phase='closed'; modal.classList.remove('is-active','is-transitioning');
    modal.hidden=true; modal.setAttribute('aria-hidden','true'); unlock();
  }
  function close() {
    if(phase!=='open') return;
    phase='closing'; modal.classList.add('is-transitioning'); modal.classList.remove('is-open');
    ready=false;clearTimeout(enterTimer);
    if(controller) controller.setActive(false);
    if(reduce.matches) finishClose();
    else closeTimer=setTimeout(finishClose,340);
  }
  panel.addEventListener('transitionend',function(e){
    if(e.target!==panel||e.propertyName!=='transform') return;
    if(phase==='closing') finishClose();
    else if(phase==='open' && !ready){
      ready=true;clearTimeout(enterTimer);modal.classList.remove('is-transitioning');
      if(controller)controller.setActive(true);
    }
  });
  document.querySelectorAll('[data-lore-open]').forEach(function(trigger){
    trigger.setAttribute('aria-haspopup','dialog'); trigger.setAttribute('aria-controls',modal.id);
    trigger.addEventListener('click',function(e){e.preventDefault();open(trigger);});
    trigger.addEventListener('pointerenter',load,{once:true});
    trigger.addEventListener('focus',load,{once:true});
  });
  modal.querySelectorAll('[data-lore-close]').forEach(function(el){el.addEventListener('click',close);});
  modal.addEventListener('keydown',function(e){
    if(phase!=='open') return;
    if(e.key==='Escape') {e.preventDefault();close();return;}
    if(e.key!=='Tab') return;
    var items=Array.from(modal.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"],video[controls]')).filter(function(el){return el.getClientRects().length;});
    var first=items[0],last=items[items.length-1];
    if(e.shiftKey && document.activeElement===first) {e.preventDefault();last.focus();}
    else if(!e.shiftKey && document.activeElement===last) {e.preventDefault();first.focus();}
  });
})();
